import { Input } from "antd";
import type { ChangeEvent } from "react";
import { Settings } from "@version2/domain-package";
import type { StringFieldData } from "./types";

type StringFieldProps = {
	settings: Settings;
	onSettingsChange: (settings: Settings) => void;
	data?: StringFieldData;
};

const StringField = ({ settings, onSettingsChange, data }: StringFieldProps) => {
	const isMultiLine = data?.multiline === true;

	if (isMultiLine) {
		return (
			<Input.TextArea
        rows={data?.rows}
        maxLength={data?.maxLength}
				value={settings?.value}
				onChange={(e: ChangeEvent<HTMLTextAreaElement>) =>
					onSettingsChange(settings.copyWith({ editedValue: e.target.value }))
				}
			/>
		);
	}

	return (
		<Input
			value={settings?.value}
			onChange={(e: ChangeEvent<HTMLInputElement>) =>
				onSettingsChange(settings.copyWith({ editedValue: e.target.value }))
			}
		/>
	);
};

export default StringField;
